import { useEffect, useState } from 'react';
import { ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import { IServerNewsPost, rage, useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import {
	setModalNewsVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledContainer,
	StyledDivider,
	StyledModalWrapper,
	StyledTextContainer,
	StyledTopContainer,
} from './ModalNews.styled';

const ModalNews = () => {
	const dispatch = useLayoutDispatch();
	const [newsPost, setNewsPost] = useState<IServerNewsPost | null>(null);
	const modalNewsId = useLayoutSelector((state) => state.modal.modalNewsId);

	useEffect(() => {
		const fetchNewsPost = async () => {
			try {
				const newsPost = await rage.game.getServerNewsPost(modalNewsId);
				setNewsPost(newsPost);
			} catch (error) {
				console.error('Error fetching news post:', error);
			}
		};

		fetchNewsPost().catch((err) => rage.notifications.showException(err));
	}, [modalNewsId]);

	useInputAction(InputAction.CommonMenuClose, () =>
		dispatch(setModalNewsVisible(false)),
	);

	return (
		<StyledModalWrapper>
			<StyledContainer>
				<StyledTopContainer>
					<Text>{newsPost ? newsPost.title : '...'}</Text>
					<CloseButton
						height={ButtonHeight.Height30}
						color={ButtonColors.Default}
						iconSize={10}
						onClick={() => dispatch(setModalNewsVisible(false))}
					/>
				</StyledTopContainer>
				<StyledDivider />
				<StyledTextContainer>
					{newsPost ? <Text>{newsPost.text}</Text> : <Text>Загрузка...</Text>}
				</StyledTextContainer>
			</StyledContainer>
		</StyledModalWrapper>
	);
};

export { ModalNews };
